// extracted by mini-css-extract-plugin
export default {"crt":"CrtFilter_crt__-R20y","scanlines":"CrtFilter_scanlines__IfdCs","flicker":"CrtFilter_flicker__torZC"};